/** @jsx jsx */
import { jsx } from '@emotion/core'
import styled from '@emotion/styled'
import React, { useState, useContext, useMemo, useEffect } from 'react'
import {
  unitIdHeader,
  modifierCol,
  modifiedDateCol,
} from 'core/HeaderColTypeProps'
import { dateCol, strCol, numCol } from '@integec/grid-tools/lib/cols'
import {
  retrieveHeatCurve,
  deleteHeatCurve,
  saveHeatCurve,
  retrieveHeatCurveSeason,
} from 'api/pgads'
import { connect } from 'react-redux'
import {
  getApiTargetInfo,
  getEnvConfig,
  getPermitActions,
  getUnits,
  hasAccesPermits,
} from 'core'
import { CriteriaRow } from 'core/screen-util'
import { Button, DatePicker, InputNumber, Select } from 'antd'
import R from 'ramda'
import { ErrorContext, PNodeZoneContext } from 'context'
import * as Actions from 'core/EventActions'

import CommonScreen from 'admin/component/CommonScreen'

import { toSelectionColProps } from '@integec/grid-tools'

import MarginAnalysisUtilityUnitSelection from './../MarginAnalysisUtilityUnitSelection'
import { getClientInfo } from '../../core/selectors'
import { APS_CLIENT } from '../../client'

const title = 'Heat Curve'

const Label = styled.div`
  display: grid;
  justify-content: end;
  align-content: center;
`

const headers = [
  //   strCol({ ident: 'unitid', display: 'Unitid', isKey: true, sortOrder: 'asc' }),
  unitIdHeader,
  dateCol({
    ident: 'effectivedate',
    display: 'Effectivedate',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
  }),
  strCol({
    ident: 'season',
    display: 'Season',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
    // ...toSelectionColProps(seasonChioce),
  }),
  numCol({
    ident: 'acoefficient',
    display: 'A-Coefficient',
    isFiltered: true,
    displayFormat: '0.00000',
    sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'bcoefficient',
    display: 'B-Coefficient',
    isFiltered: true,
    displayFormat: '0.00000',
    sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'ccoefficient',
    display: 'C-Coefficient',
    isFiltered: true,
    displayFormat: '0.000000',
    sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'dcoefficient',
    display: 'D-Coefficient',
    isFiltered: true,
    displayFormat: '0.000000',
    sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'perfFactor',
    display: 'Perf. Factor',
    isFiltered: true,
    sortOrder: 'asc',
    displayFormat: '0.000000',
    width: 150,
  }),
  modifierCol,
  modifiedDateCol,
]

const HeatRateCurve = ({
  targetInfo,
  envConfig,
  actionPermits,
  CLIENT,
  // eslint-disable-next-line no-unused-vars
  ...props
}) => {
  // const { selectedUnits } = useContext(UnitSelectionContext)
  const { setError } = useContext(ErrorContext)
  const [insertEvent, setInsertEvent] = useState(false)
  // eslint-disable-next-line no-unused-vars
  const [editMode, setEditMode] = useState(true)

  const [seasonMap, setSeasonMap] = useState({})

  const { unitIdEmktIdMap, marginUnitsList, emktIdUnitNameMap } = useContext(
    PNodeZoneContext
  )

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <CriteriaRow>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns:
            '90px 100px 100px 150px 100px 150px 100px 100px 150px 150px',
          gridGap: '5px',
        }}
      >
        <Label>Unit:</Label>
        <div style={{ gridColumn: 'span 3' }}>
          <MarginAnalysisUtilityUnitSelection
            utility={insertData.utility || null}
            unit={insertData.unit || null}
            onUnitChange={value => {
              // setUtilityUnit(value)
              setInsertData({
                ...insertData,
                utility: value[0],
                unit: value[1],
                unitId: unitIdEmktIdMap[value[1]],
              })
            }}
            style={{ width: '100%' }}
            showX2X3
          />
        </div>
        <Label>Effective Date:</Label>
        <DatePicker
          allowClear={false}
          format="MM/DD/YYYY"
          value={insertData.effectivedateObj}
          onChange={date => {
            setInsertData({
              ...insertData,
              effectivedate: date.format('YYYY-MM-DD'),
              effectivedateObj: date,
            })
          }}
          style={{ width: '100%' }}
        />
        {/* {CLIENT === APS_CLIENT && <div style={{ gridColumnEnd: 'span 2' }} />} */}
        {CLIENT !== APS_CLIENT && <Label>Season :</Label>}
        {CLIENT !== APS_CLIENT && (
          <Select
            value={insertData.season}
            onChange={value => setInsertData({ ...insertData, season: value })}
            style={{ width: '100%' }}
          >
            {Object.keys(seasonMap).map(m => (
              <Select.Option key={m} value={m}>
                {m}
              </Select.Option>
            ))}
          </Select>
        )}
        <div
          style={{
            gridColumnEnd: CLIENT === APS_CLIENT ? 'span 2' : 'span 1',
            display: 'grid',
            justifyContent: 'end',
            alignContent: 'center',
          }}
        >
          Performance Factor:
        </div>
        <InputNumber
          style={{
            width: '100%',
            gridColumnEnd: CLIENT === APS_CLIENT ? 'span 2' : 'span 1',
          }}
          value={insertData.perfFactor}
          defaultValue={0}
          onChange={value =>
            setInsertData({ ...insertData, perfFactor: value })
          }
        />
        <Label>A Coefficient:</Label>
        <InputNumber
          style={{ width: '100%' }}
          defaultValue={0}
          value={insertData.acoefficient}
          onChange={value =>
            setInsertData({ ...insertData, acoefficient: value })
          }
        />
        <Label>B Coefficient:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.bcoefficient}
          defaultValue={0}
          onChange={value =>
            setInsertData({ ...insertData, bcoefficient: value })
          }
        />
        <Label>C Coefficient:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.ccoefficient}
          defaultValue={0}
          onChange={value =>
            setInsertData({ ...insertData, ccoefficient: value })
          }
        />
        <Label>D Coefficient:</Label>
        <InputNumber
          style={{ width: '100%' }}
          defaultValue={0}
          value={insertData.dcoefficient}
          onChange={value =>
            setInsertData({ ...insertData, dcoefficient: value })
          }
        />
        <div
          style={{
            gridColumn: 'span 2',
            gridRowGap: '10px',
            width: '100%',
            display: 'grid',
            gridTemplateColumns: 'auto auto auto',
            paddingLeft: '5px',
            gridColumnGap: '10px',
          }}
        >
          <Button type="primary" onClick={() => onAdd(true)}>
            Add
          </Button>
          <Button type="primary" onClick={() => onAdd(false)}>
            Add & Hide
          </Button>
          <Button type="danger" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </div>
    </CriteriaRow>
  )

  useEffect(
    _ => {
      retrieveHeatCurveSeason(targetInfo).fork(setError, data => {
        const seasonMap = R.fromPairs(data.map(d => [d.season, d.season]))
        setSeasonMap(seasonMap)
      })
    },
    [setError, targetInfo]
  )

  const headerWithFormatter = headers.map(header =>
    header.ident === 'unitId' || header.ident === 'unitid'
      ? {
          ...header,
          dataFormatter: ({ value }) => emktIdUnitNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            emktIdUnitNameMap[rowData.unitId] ||
            emktIdUnitNameMap[rowData.unitid] ||
            rowData.unitId ||
            rowData.unitid,
        }
      : header.ident === 'season'
      ? { ...header, ...toSelectionColProps(seasonMap) }
      : header
  )

  const writeEventActionPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          Actions.MARGIN_ANALYSIS_ADMIN,
          Actions.MARGIN_ANALYSIS_CORE_WRITE,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const writePermission = useMemo(_ => writeEventActionPermission && editMode, [
    writeEventActionPermission,
    editMode,
  ])

  const withCriteria = (state, props, selectedUnits, selectedDate) => {
    return {
      date: selectedDate,
      units: (selectedUnits || [])
        .filter(e => !!e)
        .map(e => unitIdEmktIdMap[e.unitId]),
    }
  }

  // writeEventActionPermission ? (
  //   <Checkbox
  //     css={{ marginLeft: '10px', minWidth: '100px' }}
  //     onChange={e => setEditMode(e.target.checked)}
  //     checked={editMode}
  //   >
  //     Edit Mode
  //   </Checkbox>
  // ) : (
  //   <div />
  // )

  const extraUnitSelectionProps = _ => ({
    limitedUnits: marginUnitsList,
    units: marginUnitsList,
    // itemToLabel: e => e.emktId,
  })

  // const modifySaveDataBeforeSave = (saveData, validateData) => {
  //   return saveData.map(s => ({ ...s, unitId: emktUnitMap[s.unitId] }))
  // }

  // eslint-disable-next-line no-unused-vars
  const isEditableGrid = ({ header, rowData }) => {
    if (
      header.ident === 'modifier' ||
      header.ident === 'modifiedDate' ||
      header.isKey
    )
      return false

    return writePermission
  }
  const sortOptions = [
    unitIdHeader,
    dateCol({
      ident: 'effectivedate',
      display: 'Effectivedate',
      isKey: true,
      sortOrder: 'asc',
      width: 150,
    }),
    strCol({
      ident: 'season',
      display: 'Season',
      isKey: true,
      sortOrder: 'asc',
      width: 150,
      // ...toSelectionColProps(seasonChioce),
    }),
  ]

  return (
    <div>
      <CommonScreen
        // modifySaveDataBeforeSave={modifySaveDataBeforeSave}
        withoutModify={!writeEventActionPermission}
        withDelete={!writeEventActionPermission}
        allowInsert={writeEventActionPermission}
        isEditableGrid={isEditableGrid}
        extraUnitSelectionProps={extraUnitSelectionProps}
        withUnitSelection
        withDatePickerTitle="Effective Date:"
        autoRetrieve={false}
        isAdminScreen={false}
        withCriteria={withCriteria}
        withDatePicker
        title={title}
        header={headerWithFormatter}
        saveTask={saveHeatCurve}
        retrieveTask={retrieveHeatCurve}
        deleteTask={deleteHeatCurve}
        altBy={u => u.unitId}
        sortOptions={sortOptions}
        initialSortOptions={sortOptions}
        widthOffset={50}
        insertComp={insertEvent && insertComp}
        insertCompHeight={120}
        onInsertEvent={b => setInsertEvent(b)}
      />
    </div>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  units: getUnits(state),
  CLIENT: getClientInfo(state),
})

export default connect(mapStateToProps)(HeatRateCurve)
